module.exports = __webpack_public_path__ + "img/7878f91.png";